<div class="cdm-modal-shell">
  <div class="cdm-modal-header">
    <div class="cdm-modal-title-wrap">
      @if (showTitleIcon) {
        <mat-icon>folder_special</mat-icon>
      }
      <h3>{{ title }}</h3>
    </div>
    <div class="cdm-modal-header-actions">
      <button
        type="button"
        class="cdm-copy-btn"
        mat-stroked-button
        (click)="copyCdmPlanToClipboard()"
        [disabled]="!canCopy"
        aria-label="Copy CDM plan as table"
        matTooltip="Copy structured table for Word or notes"
        matTooltipPosition="below">
        <mat-icon>{{ copyState === 'copied' ? 'check' : 'content_copy' }}</mat-icon>
        <span>{{ copyState === 'copied' ? 'Copied' : 'Copy' }}</span>
      </button>

      <button
        *ngIf="!isLIC"
        type="button"
        class="cdm-export-btn"
        mat-stroked-button
        (click)="exportCdmPlanToPdf()"
        [disabled]="!canExport"
        aria-label="Export CDM plan as PDF"
        matTooltip="Export CDM plan table to PDF"
        matTooltipPosition="below">
        <mat-icon>{{ pdfState === 'error' ? 'error_outline' : pdfState === 'exporting' ? 'hourglass_top' : 'picture_as_pdf' }}</mat-icon>
        <span>{{ pdfState === 'error' ? 'Failed' : pdfState === 'exporting' ? 'Generating...' : 'Export PDF' }}</span>
      </button>

      <button type="button" class="cdm-close-btn" mat-icon-button mat-dialog-close aria-label="Close CDM dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="cdm-modal-body">
    @if (isLoading) {
      <div class="cdm-loading-row">
        <mat-icon>autorenew</mat-icon>
        <span>Generating CDM plan...</span>
      </div>
    } @else if (errorMessage) {
      <div class="cdm-error-row">
        <mat-icon>error_outline</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>
    } @else if (rawResponse) {
      <!-- <div class="cdm-goal-block">
        <pre class="cdm-json-view">{{ rawResponse | json }}</pre>
      </div> -->

      @if (eligibility) {
        <div class="cdm-eligibility-block">
          @if (showEligibilityLabel) {
            <span class="cdm-eligibility-label">CDM Eligibility:</span>
          }
          <strong class="cdm-eligibility-value">{{ eligibility }}</strong>
          @if (eligibilityReason) {
            <mat-icon
              class="cdm-eligibility-info-icon"
              [matTooltip]="eligibilityReason"
              matTooltipClass="cdm-eligibility-tooltip"
              matTooltipPosition="right">info</mat-icon>
          }
        </div>
      }

      <div class="cdm-goal-block">
        <p class="cdm-goal-label">Patient's SMART goal for their health within the next 12 months:</p>
        <p class="cdm-goal-value">{{ annualSmartGoal }}</p>
      </div>

      <div class="cdm-table-wrap">
        <table class="cdm-plan-table">
          <thead>
            <tr>
              <th>Relevant conditions in this plan</th>
              <th>Patient lifestyle goals - To be achieved</th>
              <th>Provider treatments &amp; patient actions</th>
              <th>Review 3-6 monthly. Have goals been met? Any further actions required?</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of planRows; let i = index; trackBy: trackByIndex">
              <td>{{ row.relevantConditions }}</td>
              <td>{{ row.patientLifestyleGoals }}</td>
              <td>{{ row.providerTreatmentsAndActions }}</td>
              <td>{{ row.reviewNotes }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="cdm-screening-section">
        <p class="cdm-goal-label">Health Prevention Screening:</p>
        <div class="cdm-table-wrap">
          <table class="cdm-plan-table cdm-screening-table">
            <thead>
              <tr>
                <th>Action</th>
                <th>Last completed</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let screeningRow of screeningRows; trackBy: trackByScreeningAction">
                <td>{{ screeningRow.action }}</td>
                <td>{{ screeningRow.lastCompleted }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    } @else {
      <p>No CDM plan data available.</p>
    }
  </div>
</div>
